import Row from '@frontend/ui-kit/Components/Row';
import Column from '@frontend/ui-kit/Components/Column';
import UserInfo from '../UserInfo';
import hjLogo from '../../../static/images/HJLogo.svg';
import headerTitle from '../../../static/images/headerTitle.svg';
import styles from './index.module.scss';

const Header = () => {
    return (
        <Row middle='xs' className={styles['header']}>
            <Column sm={3}/>

            <Column sm={6} className={styles['header-logos']}>
                <div className={styles['header-logos-healthjoy']}>
                    <img src={hjLogo} alt='HealthJoy' className={styles['header-logos-healthjoy__logo']}/>
                    <img src={headerTitle} alt='Benefits Studio' className={styles['header-logos-healthjoy__title']}/>
                </div>
            </Column>

            <Column sm={3} className={styles['header-user']}>
                <UserInfo/>
            </Column>
        </Row>
    );
};

export {Header as TestableHeader};
export default Header;
